import { useSubscription } from "@/helper/useSubscription";
import { Report, REPORT_TYPE } from "@/models/report";
import { OPTIONS_SUBSCRIPTION } from "@/models/subscription";
import { User } from "@/models/user";
import { Box } from "@mui/material";
import { useMemo } from "react";

interface Props extends Partial<Report> {
  user: User;
}

const EmbedIframe = ({
  embedUrlDemo,
  embedUrlProduction,
  user,
  type,
}: Props) => {
  const { hasPermission } = useSubscription(user?.license);
  const handleGetEmbedUrl = useMemo(() => {
    if (type === REPORT_TYPE.FREE) {
      return embedUrlProduction;
    }
    if (hasPermission(OPTIONS_SUBSCRIPTION.EMBED)) {
      return embedUrlProduction;
    }
    return embedUrlDemo;
  }, [embedUrlDemo, embedUrlProduction, hasPermission]);

  return (
    <Box
      id={"embed-report-container"}
      className="flex justify-center !overflow-visible"
    >
      <div className=" w-full lg:w-[1440px] !overflow-visible h-[80vh] md:h-[90vh] bg-[#F0F2F9] ">
        <iframe
          title="embed-iframe"
          src={handleGetEmbedUrl}
          width="100%"
          height="100%"
          style={{ border: "1px solid #ccc" }}
          className="rounded-md shadow-md"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </Box>
  );
};

export default EmbedIframe;
